import React from 'react';
const OptimizelyContext = /*#__PURE__*/React.createContext({
  disabled: true
});
export default OptimizelyContext;